<template>
    <div class="declares_step3_form">
        <div class="header_content">
            <h3 class="title">证明材料</h3>
        </div>
        <div>
            <uploadFile group_id="sczykh_qyzc_sqb" :StuId="StuId" />
            <uploadFile group_id="sczykh_sfz_1" :StuId="StuId" />
            <uploadFile group_id="sczykh_sfz_2" :StuId="StuId" />
            <uploadFile group_id="sczykh_qyzc_lcsjnxzm" :StuId="StuId" />
            <!-- <uploadFile group_id="sczykh_zmbsz" :StuId="StuId" /> -->
        </div>
    </div>
</template>
<script>
import uploadFile from "@/views/declare/base/step3/uploadFile";
import util from "@/libs/util";
export default {
    components: {
        uploadFile
    },
    data() {
        return {
            StuId:''
        }
    },
    mounted() {
        this.StuId = util.storage.getUserInfo().obj_id;
    },
}
</script>